<app-header></app-header>

<div class="container-fluid" style="width: 80%">
    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active">Anagrafica Operatori</li>
                </ol>
            </nav>
        </div>
    </div>

    <div *ngIf="loading" class="d-flex justify-content-center align-items-center p-5">
        <mat-spinner diameter="50"></mat-spinner>
        <span class="ms-3">Caricamento in corso...</span>
    </div>

    <div *ngIf="!loading">
        <mat-card class="p-2 mb-4" appearance="outlined">
            <mat-card-header>
                <mat-card-title>Filtri di ricerca</mat-card-title>
            </mat-card-header>
            <form [formGroup]="formRicerca" (ngSubmit)="cerca()" class="m-4">
                <div class="row g-3">
                    <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Nome o Cognome</mat-label>
                        <input matInput formControlName="testoRicerca" placeholder="Es: Mario Rossi">
                        <mat-icon matSuffix>person</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Qualifiche</mat-label>
                        <mat-select formControlName="codiceQualifiche" multiple placeholder="Tutte le qualifiche">
                            <mat-option *ngFor="let q of listaQualifiche" [value]="q.codice">
                                {{ q.descrizione }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Struttura</mat-label>
                        <mat-select formControlName="idStruttura">
                            <mat-option [value]="''">Tutte le strutture</mat-option>
                            <mat-option *ngFor="let s of listaStrutture" [value]="s.id">
                                {{ s.denominazione }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="d-flex mt-3">
                    <button mat-flat-button color="primary" type="submit">
                        <mat-icon>search</mat-icon>Cerca
                    </button>
                    <div style="margin-left: 0.4rem;"></div>
                    <button mat-button type="button" (click)="pulisciForm()">
                        <mat-icon>clear</mat-icon>Pulisci form
                    </button>
                </div>
            </form>
        </mat-card>

        <div class="alert alert-primary mb-4" role="alert">
            Operatori trovati: <b>{{pageElements}}</b>
        </div>

        <mat-card class="p-2" appearance="outlined">
            <mat-card-header>
                <mat-card-title>Risultati</mat-card-title>
            </mat-card-header>

            <div class="table-container mt-3">
                <table mat-table matSort [dataSource]="dataSource" (matSortChange)="handleSortEvent($any($event))"
                    class="w-100">

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
                        <td mat-cell *matCellDef="let op">{{op.id}}</td>
                    </ng-container>

                    <ng-container matColumnDef="nominativo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nominativo</th>
                        <td mat-cell *matCellDef="let op"><b>{{op.cognome}}</b> {{op.nome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="codiceFiscale">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Codice Fiscale</th>
                        <td mat-cell *matCellDef="let op">{{op.codiceFiscale}}</td>
                    </ng-container>

                    <ng-container matColumnDef="strutture">
                        <th mat-header-cell *matHeaderCellDef>Strutture</th>
                        <td mat-cell *matCellDef="let op">
                            <span *ngFor="let s of op.strutture; let last = last">
                                {{ s.denominazione }}{{ !last ? ', ' : '' }}
                            </span>
                            <span *ngIf="!op.strutture || op.strutture.length === 0">-</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qualifiche">
                        <th mat-header-cell *matHeaderCellDef>Qualifiche</th>
                        <td mat-cell *matCellDef="let op">
                            <span *ngFor="let q of op.qualifiche"
                                class="badge rounded-pill bg-light text-primary border border-primary me-1">
                                {{ q.descrizione }}
                            </span>
                            <span *ngIf="!op.qualifiche || op.qualifiche.length === 0">-</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="vaiAlDettaglio(row.id)"
                        class="clickable-row">
                    </tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                            Nessun risultato.
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageIndex]="pageIndex" [length]="pageElements" [pageSize]="pageSize"
                    [pageSizeOptions]="[5, 10, 20]" (page)="handlePageEvent($event)" showFirstLastButtons>
                </mat-paginator>
            </div>
        </mat-card>
    </div>
</div>

<app-footer></app-footer>